export const getwtmSessionDetails = state => state.webToMobile;
